import { c as _c } from "react/compiler-runtime";
import ImageComponent from "@/components/ui/image";
import { ChevronDown } from "lucide-react";
import React, { useState, useRef, useEffect, ChangeEvent } from "react";
interface CustomDropDownProps {
  label?: string;
  options: {
    id: string;
    name: string;
  }[];
  allowInput?: boolean;
  placeholder: string;
  // Make sure these two lines are present in your CustomDropDown.tsx file
  onSelect: (option: {
    id: string;
    name: string;
  }) => void;
  selectedOption?: {
    id: string;
    name: string;
  } | null;
}
const CustomDropDown: React.FC<CustomDropDownProps> = t0 => {
  const $ = _c(32);
  const {
    label,
    options,
    allowInput: t1,
    placeholder,
    onSelect,
    selectedOption
  } = t0;
  const allowInput = t1 === undefined ? false : t1;
  const [isOpen, setIsOpen] = useState(false);
  const [internalSelectedOption, setInternalSelectedOption] = useState(selectedOption || null);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  let t2;
  let t3;
  if ($[0] !== selectedOption) {
    t2 = () => {
      setInternalSelectedOption(selectedOption || null);
    };
    t3 = [selectedOption];
    $[0] = selectedOption;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== isOpen) {
    t4 = () => {
      setIsOpen(!isOpen);
    };
    $[3] = isOpen;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const toggleDropdown = t4;
  let t5;
  if ($[5] !== onSelect) {
    t5 = option => {
      setInternalSelectedOption(option);
      onSelect(option);
      setIsOpen(false);
    };
    $[5] = onSelect;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const handleSelectOption = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e => {
      setInternalSelectedOption({
        name: e.target.value,
        id: ""
      });
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const handleInputChange = t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const handleClickOutside = t7;
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    };
    t9 = [];
    $[9] = t8;
    $[10] = t9;
  } else {
    t8 = $[9];
    t9 = $[10];
  }
  useEffect(t8, t9);
  let t10;
  if ($[11] !== label) {
    t10 = label && <h3 className="font-normal text-[#3E3F41] lg:text-lg text-xs  font-outfit">Select {label}</h3>;
    $[11] = label;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== allowInput || $[14] !== internalSelectedOption || $[15] !== placeholder || $[16] !== toggleDropdown) {
    t11 = allowInput ? <input type="text" className="lg:px-12 px-4 placeholder:text-[#9ca3af] py-3 border rounded-md outline-none appearance-none w-full text-left text-[#787878]" value={internalSelectedOption?.name || ""} onClick={toggleDropdown} onChange={handleInputChange} placeholder={placeholder} ref={inputRef} /> : <button className="lg:px-12 px-4 py-3 border rounded-md outline-none appearance-none w-full text-left text-[#787878]" onClick={toggleDropdown}><span className={`lg:text-lg text-sm
                ${internalSelectedOption ? "font-medium text-[#3e3f41] font-outfit " : ""}
              `}>{internalSelectedOption?.name || placeholder}</span></button>;
    $[13] = allowInput;
    $[14] = internalSelectedOption;
    $[15] = placeholder;
    $[16] = toggleDropdown;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const t12 = `absolute right-4 top-2/4 transform -translate-y-2/4 transition-transform duration-300 ${isOpen ? "rotate-180" : ""} pointer-events-none text-[#a7a3a3]`;
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ChevronDown size={20} />;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t12) {
    t14 = <div className={t12}>{t13}</div>;
    $[19] = t12;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== handleSelectOption || $[22] !== isOpen || $[23] !== options) {
    t15 = isOpen && <ul className="absolute w-full border rounded mt-1 bg-white z-10 text-[#555555] font-outfit text-base tracking-wide font-normal">{options.map(t16 => {
        const {
          name,
          id
        } = t16;
        return <li key={id} className="px-12 py-2 hover:text-[#037A6A] cursor-pointer" onClick={() => handleSelectOption({
          name,
          id
        })}>{name}</li>;
      })}</ul>;
    $[21] = handleSelectOption;
    $[22] = isOpen;
    $[23] = options;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t11 || $[26] !== t14 || $[27] !== t15) {
    t16 = <div className="relative">{t11}{t14}{t15}</div>;
    $[25] = t11;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t10 || $[30] !== t16) {
    t17 = <div className="space-y-2 w-full" ref={dropdownRef}>{t10}{t16}</div>;
    $[29] = t10;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  return t17;
};
export default CustomDropDown;